import { render, staticRenderFns } from "./TerminalSwitchDialog.vue?vue&type=template&id=b1f86b24&scoped=true&"
import script from "./TerminalSwitchDialog.vue?vue&type=script&lang=js&"
export * from "./TerminalSwitchDialog.vue?vue&type=script&lang=js&"
import style0 from "./TerminalSwitchDialog.vue?vue&type=style&index=0&id=b1f86b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f86b24",
  null
  
)

export default component.exports